import { InputAdornment } from '@mui/material';
import { TextField } from '@mui/material'
import React from 'react'

const CustomInput = (props) => {
    const {
        value,
        placeholder = "",
        onChange,
        label,
        error,
        multiline = false,
        rows = 5,
        type = "text",
        variant = "outlined",
        endAdornment = false,
        startAdornment = false,
        startAdornmentIcon = null,
        endAdornmentIcon = null,
        regex = null,
    } = props

    const material = {
        background: "white",
        width: "100%",
        color: "black",
        '& input::placeholder': {
            color: "black"
        },
        '& label.Mui-focused': {
            color: '#EF4444'
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EF4444' 
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: "4px",
            color: "black",
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgba(239, 68, 68, .3)"
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: "rgba(239, 68, 68, .6)"
        },
        '& .MuiFormHelperText-root.Mui-error': {
            margin: 0,
            marginTop: "10px",
        },
        '& .MuiInputLabel-root': {
            color: "gray"
        }
    }

    const handleChange = (e) => {
        if(regex === "number") {
            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
            onChange(onlyNums)
        }else {
            onChange(e.target.value)
        }
    }

    return (
        <TextField
            value={value}
            placeholder={placeholder}
            helperText={error ? error.message : null}
            onChange={handleChange}
            label={label}
            error={!!error}
            sx={material}
            multiline={multiline}
            rows={rows}
            type={type}
            variant={variant}
            InputProps={{
                startAdornment: startAdornment && (
                    <InputAdornment position='start' style={{ width: "fit-content", marginRight: "10px", color: "gray" }}>
                        {startAdornmentIcon}
                    </InputAdornment>
                ),
                endAdornment: endAdornment && (
                    <InputAdornment position='end' style={{ width: "fit-content", marginRight: "10px" }}>
                        {endAdornmentIcon}
                    </InputAdornment>
                )
            }}
        />
    )
}

export default CustomInput